import React from 'react';
import './AdminPage.css';

const AdminPage: React.FC = () => {
  return (
    <div className="admin-container">
      <div className="admin-paper">
        <h1 className="admin-title">
          Yönetim Paneli
        </h1>
        <p className="admin-description">
          Bu sayfa geliştirilecek... Kullanıcı yönetimi, kategori yönetimi ve diğer admin işlemleri burada olacak.
        </p>
      </div>
    </div>
  );
};

export default AdminPage;